import PageComponent from '../base/PageComponent';
import Map from './PropertyMap';
import {markerStyles, markerInfoWindowTemplate} from './includes/MapModuleSettings';

export default class MapModule extends PageComponent {
    init(){
        this.initMap();
    }

    initMap() {
        var map = this.childElements('#map');
        if(map.length){
            var location = {Latitude:map.data('latitude'), Longitude:map.data('longitude'), Address:map.data('address')};
            var locations = JSON.stringify([location]);

            this.map = new Map(map, '', markerStyles, markerInfoWindowTemplate);
            this.map.locations = locations;
            this.map.minZoom = 12;
            this.map.maxZoom = 16;
            this.map.init();
        }
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/MapModule.js